var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simple-page",class:_vm.backgroundColor},[_c('SimpleHeader'),_vm._v(" "),_c('div',{staticClass:"simple-page__main g-pc-mt-24 g-mb-32"},[_vm._t("default")],2),_vm._v(" "),_c('SimpleFooter',{staticClass:"g-mb-16"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }